import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LocationCard.css';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';

const LocationCard = ({ city, address, coords }) => {
    const [mapEnabled, setMapEnabled] = useState(false);

    const mapImage = city === 'Olhão' ? 'images/olhao-placeholder-map.avif' : 'images/tavira-placeholder-map.avif'

    const gmapsUrl = `https://www.google.com/maps/search/?api=1&query=${coords.lat},${coords.lng}`;

    const { t } = useTranslation();

    return (
        
        <div className="location-card">
            <div className="location-info">
                <h2>{city}</h2>
                {city === "Olhão" ? <OlhaoInfo /> : <TaviraInfo />}
            </div>
            <div className = "gmaps-embed-container">
                {!mapEnabled ? (
                    <div className="map-placeholder">
                        <img
                            src={mapImage}
                            alt={`Map showing the area around ${city}`}
                            loading="lazy"
                            
                        />
                        <div
                            className="map-overlay"
                            onClick={() => setMapEnabled(true)}>
                            <p className="map-disclaimer">
                                {t('map-disclaimer')}
                            </p>
                        </div>
                    </div>
                ) : (
                    <APIProvider apiKey={process.env.REACT_APP_GMAPS_API_KEY}>
                        <Map
                            defaultZoom={15}
                            defaultCenter={ { lat: coords.lat, lng: coords.lng } }>
                        <Marker
                            position={ { lat: coords.lat, lng: coords.lng } }
                            onClick={() => window.open(gmapsUrl, "_blank")} />
                        </Map>
                    </APIProvider>
                )} 
            </div>
        </div>
    );
};

const OlhaoInfo = () => {
    const { t } = useTranslation();
    return (
        <div className="info-container">
            <a href="tel:+351289153829">+351 289 153 829</a>
            <p>{t('hours')}: 12:00 - 15:00, 19:00 - 23:00</p>
            <a href="https://maps.app.goo.gl/1JEBDZxNjmRSnQVH6" target="_blank" rel="noreferrer">R. Vasco da Gama, 8700-522 Olhão, Portugal</a>
        </div>
    )
}

const TaviraInfo = () => {
    const { t } = useTranslation();
    return (
        <div className="info-container">
            <a href="tel:+351281327685">+351 281 327 685</a>
            <p>{t('hours')}: 12:00 - 15:00, 19:00 - 23:00</p>
            <a href="https://maps.app.goo.gl/ZSRC9vmcMSCujyRu5" target="_blank" rel="noreferrer">R. Gonçalo Velho 16, 8800-349 Tavira, Portugal</a>
        </div>
    )
}

export default LocationCard;